module.exports = __webpack_public_path__ + "media/images/Employee-Welcome-e03773fb5c7ad4213b9c9338f6f1cada.svg";